// 学校一覧のヘッダ色
export const tableHeaderClass: string[] = ['tableHeader subtitle-2'];

// 1ページごとの表示数の選択肢
export const tableFooterProps = {
  'items-per-page-options': [10, 50, 100],
};
